import {ArchiveIcon, LockIcon, type OcticonProps, RepoForkedIcon, RepoIcon} from '@primer/octicons-react'

type RepositoryIconProps = Omit<OcticonProps, 'icon' | 'aria-label'> & {
  status: string
  /** Leaves the icon unnamed, for a control whose own name already says what it is. */
  decorative?: boolean
}

export function RepositoryIcon({status, decorative = false, ...props}: RepositoryIconProps) {
  const label = (name: string) => (decorative ? undefined : name)
  switch (status) {
    case 'archived':
      return <ArchiveIcon aria-label={label('Archived repository')} {...props} />
    case 'forked':
      return <RepoForkedIcon aria-label={label('Forked repository')} {...props} />
    case 'public':
      return <RepoIcon aria-label={label('Public repository')} {...props} />
    case 'private':
      return <LockIcon aria-label={label('Private repository')} {...props} />
    default:
      return <RepoIcon aria-label={label('Repository')} {...props} />
  }
}
